﻿import nlHome from "./nl/home";
import nlDiensten from "./nl/diensten";
import nlWieZijnWij from "./nl/wie-zijn-wij";
import nlContact from "./nl/contact";
import nlKozijnReparatie from "./nl/kozijn-reparatie";
import nlSchuifpuiReparatie from "./nl/schuifpui-reparatie";
import nlDraaikiepraamReparatie from "./nl/draaikiepraam-reparatie";
import nlSlotCilinderVervangen from "./nl/slot-cilinder-vervangen";
import nlGlasVervangen from "./nl/glas-vervangen";
import nlVeluxReparatie from "./nl/velux-reparatie";
import nlInbraakschadeReparatie from "./nl/inbraakschade-reparatie";
import nlRaamkrukVervangen from "./nl/raamkruk-vervangen";
import nlAlgemeneVoorwaarden from "./nl/algemene-voorwaarden";
import nlPrivacybeleid from "./nl/privacybeleid";
import nlCookiebeleid from "./nl/cookiebeleid";
import nlSlotenmakerEindhoven from "./nl/slotenmaker-eindhoven";
import nlWijken from "./nl/wijken";
import nlBlog from "./nl/blog";
import nlBlogIsde from "./nl/blog-isde";
import nlBlogCondens from "./nl/blog-condens";
import nlBlogKozijnSchilderen from "./nl/blog-kozijn-schilderen";
import nlBlogHrGlas from "./nl/blog-hr-glas";
import nlBlogIsdeEindhoven from "./nl/blog-isde-eindhoven";

const resources = {
  nl: {
    home: nlHome,
    diensten: nlDiensten,
    "wie-zijn-wij": nlWieZijnWij,
    contact: nlContact,
    "kozijn-reparatie": nlKozijnReparatie,
    "schuifpui-reparatie": nlSchuifpuiReparatie,
    "draaikiepraam-reparatie": nlDraaikiepraamReparatie,
    "slot-cilinder-vervangen": nlSlotCilinderVervangen,
    "glas-vervangen": nlGlasVervangen,
    "velux-reparatie": nlVeluxReparatie,
    "inbraakschade-reparatie": nlInbraakschadeReparatie,
    "raamkruk-vervangen": nlRaamkrukVervangen,
    "algemene-voorwaarden": nlAlgemeneVoorwaarden,
    privacybeleid: nlPrivacybeleid,
    cookiebeleid: nlCookiebeleid,
    "slotenmaker-eindhoven": nlSlotenmakerEindhoven,
    wijken: nlWijken,
    blog: nlBlog,
    "blog-isde": nlBlogIsde,
    "blog-condens": nlBlogCondens,
    "blog-kozijn-schilderen": nlBlogKozijnSchilderen,
    "blog-hr-glas": nlBlogHrGlas,
    "blog-isde-eindhoven": nlBlogIsdeEindhoven,
  },
};

export default resources;
